// i18n area 'auth' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.fi-FI.meta.json.
import type { enUS } from './auth'

export const fiFI: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Kirjaudu tilillesi',
    username: 'Käyttäjänimi',
    usernamePlaceholder: 'Syötä käyttäjänimi',
    usernameHint: 'Käytä muotoa käyttäjä@domain todentautuaksesi directory-realmiin',
    continue: 'Jatka',
    changeUser: 'Etkö olekaan sinä?',
    password: 'Salasana',
    forgotPassword: 'Unohtuiko salasana?',
    submit: 'Kirjaudu',
    otp: 'Kertakäyttökoodi',
    otpSubtitle: 'Syötä todennussovelluksesi koodi',
    otpHint: 'Kuusi numeroa todennussovelluksesta tai yksi palautuskoodeista',
    otpSubmit: 'Tarkista',
    invalidCredentials: 'Virheellinen käyttäjänimi tai salasana',
    tooManyAttempts: 'Liikaa yrityksiä — odota hetki ja yritä uudelleen',
    realmUnavailable: 'Realm ei voi juuri nyt tarkistaa tunnistetietoja — klusterin store ei ole tavoitettavissa. Kirjaudu paikallisena käyttäjänä (break-glass).',
    genericError: 'Kirjautuminen epäonnistui — onko TVirt-backend tavoitettavissa?'
  },
  user: {
    logout: 'Kirjaudu ulos',
    password: {
      menu: 'Vaihda salasana',
      title: 'Vaihda salasanasi',
      current: 'Nykyinen salasana',
      new: 'Uusi salasana',
      confirm: 'Vahvista uusi salasana',
      mismatch: 'Salasanat eivät täsmää',
      error: 'Salasanaa ei voitu vaihtaa',
      forcedTitle: 'Vaihda salasana jatkaaksesi',
      forcedHint: 'Tämän salasanan asetti ylläpitäjä, ja se on vaihdettava ennen sisäänpääsyä.',
      forcedSubmit: 'Vaihda ja kirjaudu'
    },
    mfa: {
      title: 'Kaksivaiheinen todennus',
      subtitle: 'Toinen tekijä vaaditaan jokaisessa kirjautumisessa',
      loadError: 'Toisen tekijän tilaa ei voitu ladata',
      enrolled: 'Käytössä',
      notEnrolled: 'Ei käytössä',
      enrolledAt: 'Otettu käyttöön',
      codesRemaining: 'Palautuskoodeja jäljellä',
      requiredHint: 'Ylläpitäjä vaatii tällä tilillä toisen tekijän: konfiguroi se nyt — siihen asti voit kirjautua, mutta et juuri muuta.',
      enroll: 'Konfiguroi',
      enrollTitle: 'Konfiguroi kaksivaiheinen todennus',
      enrollHint: 'Skannaa tämä koodi todennussovelluksella ja syötä sitten sen näyttämä koodi vahvistukseksi.',
      secretHint: 'Etkö saa skannattua? Syötä tämä salaisuus sovellukseen:',
      code: 'Koodi sovelluksesta',
      confirm: 'Vahvista',
      startError: 'Konfigurointia ei voitu aloittaa',
      confirmError: 'Konfigurointia ei voitu vahvistaa',
      codesTitle: 'Palautuskoodisi',
      codesWarning: 'Nämä koodit näytetään vain kerran. Tallenna ne nyt: kullakin pääset kirjautumaan, kun todennussovellus ei ole saatavilla, ja kukin kelpaa vain kerran.',
      codesAck: 'Olen tallentanut palautuskoodit',
      codesDone: 'Valmis',
      copy: 'Kopioi',
      copied: 'Kopioitu',
      download: 'Lataa',
      regenerate: 'Uudet palautuskoodit',
      regenerateTitle: 'Luo palautuskoodit uudelleen',
      regenerateHint: 'Kaikki tähän mennessä myönnetyt koodit lakkaavat toimimasta sillä hetkellä, kun uusi setti luodaan.',
      regenerateConfirm: 'Luo uudelleen',
      regenerateError: 'Palautuskoodeja ei voitu luoda uudelleen',
      remove: 'Poista',
      removeTitle: 'Poista toinen tekijä',
      removeConfirm: 'Poista',
      removeHint: 'Tili palaa pelkkään salasanaan. Voit konfiguroida toisen tekijän uudelleen milloin vain.',
      removeRequiredHint: 'Ylläpitäjä vaatii tällä tilillä toisen tekijän, joten palvelin hylkää poiston — pyydä ensin vaatimuksen poistoa.',
      removeError: 'Toista tekijää ei voitu poistaa'
    },
    profile: {
      menu: 'Siirry profiiliini',
      sessions: 'Aktiiviset istunnot',
      sessionsHint: 'Avoimet istuntosi tällä solmulla',
      sessionsEmpty: 'Ei aktiivisia istuntoja',
      sessionCreated: 'Kirjauduttu',
      sessionExpires: 'Vanhenee',
      revoke: 'Mitätöi istunto',
      revokeError: 'Istuntoa ei voitu mitätöidä',
      loadError: 'Istuntoja ei voitu ladata'
    }
  }
}
